import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: () => import('../components/Home.vue')
    },
    {
      path: '/item-data',
      name: 'ItemData',
      component: () => import('../components/ItemData.vue') // 使用动态导入
    }
  ]
})

// 添加导航守卫用于调试
router.beforeEach((to, from, next) => {
  console.log('Navigation:', {
    to: to.path,
    matched: to.matched.length > 0
  })
  next()
})

export default router